<div class="modal-slider-container">
  <div class="slide-content">
    <div class="slides-wrapper" [style.transform]="'translateX(-' + currentIndex * slideElem?.nativeElement?.offsetWidth + 'px)'">
      <div class="slide" *ngFor="let item of tickets; let i = index" #slideElem>
        <div class="most-played-ticket-detail-general-card">
          <div class="card-header-row">
            <div class="card-header-col">
              <div class="card-header-number-container">
                <div class="number-value" [ngClass]="item.IsCountUp ? 'increase' : 'stable'">{{ 'mostplayed_2' | translate }} {{ i + 1 }}</div>
                <div class="arrow-increase" *ngIf="item.IsCountUp"></div>
                <div></div>
              </div>
            </div>
            <div class="card-header-col">
              <div class="card-header-number-container">
                <span>{{ item.EventCount }}{{ 'mostplayed_4' | translate }} {{ 'Combi' | translate }}</span>
              </div>
            </div>
            <div class="card-header-col">
              <div class="close" (click)="closeModal()">X</div>
            </div>
          </div>
          <div class="match-detail-container-card-body">
            <ng-container *ngFor="let match of item.data.reverse() | groupByEventName; first as isFirst">
              <div class="match-detail-container">
                <div class="match-detail-row">
                  <div class="match-info-left-container">
                    <div class="match-type">
                      <span class="type">{{ 'Type_' | translate }} </span
                      ><span class="type-name"
                        >{{ match.OddsType }} {{ match.SpecialBetValue }}&nbsp;:&nbsp;<b>{{ match.Outcomes }}</b></span
                      >
                    </div>
                    <div class="match-info-desc">
                      <ng-container *ngIf="('teamImageAssetsUrl' | getEnv) !== ''">
                        <team-uniform-utils [extraClass]="'most-play-uniform'" [teamId]="match.HomeTeamId"></team-uniform-utils> </ng-container
                      >{{ match.EventName }}
                      <ng-container *ngIf="('teamImageAssetsUrl' | getEnv) !== ''">
                        <team-uniform-utils [extraClass]="'most-play-uniform'" [teamId]="match.AwayTeamId"></team-uniform-utils>
                      </ng-container>
                    </div>
                    <div class="match-info-date">
                      {{ match.EventDate | dateFormat : 'dd.MM.yy HH:mm' }}
                    </div>
                  </div>
                  <div class="odd {{ checkOddId(match?.eEvents[0]?.OddId) }}" (click)="clickNewOdd(match?.eEvents[0])">
                    <span class="odd-text">{{ match.Outcomes }}</span>

                    <span class="odd-value">{{ match.OddValue | oddFormat }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="match-detail-container-car-footer">
            <div class="footer-button-container">
              <div class="prev-button" (click)="prevItem()">
                <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
              </div>
              <div class="btn colored register-button save-changes-button confirm-button blue-placebet" (click)="placeAllTicket()">
                <div class="btn-text">
                  {{ 'mostplayed_3' | translate }} <span style="margin-left: 5px; font-weight: 800"> {{ STAKE_AMOUNT * item.TotalOddValue | balanceFormat }}</span>
                </div>
              </div>
              <div class="next-button" (click)="nextItem()">
                <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
